import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';

export type UserOption = {
  id: string;
  name: string;
  email: string;
  designation: string | null;
};

/**
 * Active colleagues, for any picker that assigns work to a person.
 *
 * Uses /users/options rather than /users: the full user list needs
 * admin.user.view, which would mean only administrators could assign a
 * ticket or name a project manager.
 */
export function useUserOptions(search?: string) {
  return useQuery({
    queryKey: ['users', 'options', search],
    queryFn: () =>
      apiGet<UserOption[]>('/users/options', { params: search ? { q: search } : undefined }),
    staleTime: 5 * 60 * 1000,
  });
}
